<template>
  <div class="login-form">
    <div class="mdl-card mdl-shadow--2dp">
      <div class="mdl-card__title mdl-card-colo">
        <h2 class="mdl-card__title-text">Sign In</h2>
      </div>
      <div class="mdl-card__supporting-text mdl-card--expand">

        <div class="error">
          <span v-if="error">{{ error }}</span>
        </div>

        <form v-on:submit="login" v-bind:class="{ blurred: state == 'working' }">

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="email" id="email" v-model="email"
                   v-bind:required="required" ref="email">
            <label class="mdl-textfield__label" for="email">Email</label>
          </div>

          <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
            <input class="mdl-textfield__input" type="password" id="password" v-model="password"
                   v-bind:required="required" ref="password">
            <label class="mdl-textfield__label" for="password">Password</label>
          </div>

          <button class="mdl-button mdl-js-button mdl-button--raised" type="submit">
            Sign In
          </button>

        </form>

        <div class="working" v-if="state == 'working'">
          <div class="mdl-spinner mdl-js-spinner is-active"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import api from "api"

export default {
  name: 'login-form',
  metaInfo: {
    title: 'Sign In'
  },
  data () {
    return {
      state: "ready",
      error: null,
      email: "",
      password: "",
      required: false
    }
  },
  methods: {
    login(e) {
      e.preventDefault()

      if(this.email.trim()=='' || this.password.trim()=='') {
        this.required = true
        if(this.email.trim()=='') {
          this.$refs.email.parentElement.setAttribute('class',
            this.$refs.email.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.email.focus()
        }
        if(this.password.trim()=='') {
          this.$refs.password.parentElement.setAttribute('class',
            this.$refs.password.parentElement.getAttribute('class')+' is-invalid')
          this.$refs.password.focus()
        }
        return
      }

      this.state = "working"
      api.request(["emailPassword", "login"], this.email, this.password).then(result => {
        this.state = "done"
      }).catch(error => {
        this.error = error
        this.state = "ready"
      })
    }
  },
  updated () {
    componentHandler.upgradeAllRegistered()
  },
  mounted () {
    componentHandler.upgradeAllRegistered()
  }
}
</script>

<style scoped>

  .login-form {
    display: flex;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: url(../../../static/images/voleadstools2.png);
    background-position: center;
    background-size: 280%;
  }

  .mdl-card {
    width: 320px;
    margin: auto;
  }
  .mdl-card__title {
    height: 110px;
    color: #fff;
    background: url(../../../static/images/voleadstools2_mid.png) 215px 5px no-repeat #241d7f;
    background-size: 100px;
  }

  button {
    background: #1d0585;
    color: white;
    font-weight: 300;
    float: right;
  }

  button:hover {
    background: #2906bf;
    color: white;
    font-weight: 300;
  }

  .mdl-card__supporting-text {
    position: relative;
  }

  form.blurred {
    filter: blur(2px);
  }

  .working {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    text-align: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
  }
  .working div {
    margin: auto;
    height: 5em;
    width: 5em;
  }

  .error {
    height: 2em;
  }

</style>



// WEBPACK FOOTER //
// LoginForm.vue?00482c3b